module.exports = __webpack_public_path__ + "img/emoji-nerd-80x80.5571447f.png";